import React, { useEffect, useMemo } from "react";
import styles from "./BillingResult.module.scss";
import BillingPart from "./BillingPart";
import { useSelector, useDispatch } from "react-redux";
import { IApplicationState } from "redux/root-reducer";
import { useParams } from "react-router";
import Overview from "./Overview";
import { getBillingResults } from "nodeDetails/nodeDetails.actions";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { BillingItemStatus } from "nodeDetails/types";

const BillingResult = () => {
  const dispatch = useDispatch();
  const {
    billingResults,
    isFetchingBillingResults: isFetching,
    fetchBillingResultsFailed,
  } = useSelector((state: IApplicationState) => state.node);

  const {
    billingResultId,
    domain,
    id: nodeId,
  } = useParams<{ domain: string; id: string; billingResultId: string }>();

  useEffect(() => {
    if (billingResults.length === 0) {
      dispatch(getBillingResults(domain, nodeId));
    }
  }, []);

  const billingResult = billingResults.find(
    (billingResult) => billingResult.ID === parseInt(billingResultId)
  );

  const filteredBillingParts = useMemo(() => {
    if (!billingResult) return [];

    return billingResult.Parts.map((part) => ({
      ...part,
      Items: part.Items.filter((item) => item.Status === BillingItemStatus.Ok),
    })).filter((part) => part.Items.length !== 0);
  }, [billingResult]);

  if (isFetching && billingResults.length === 0) {
    return (
      <Backdrop open={isFetching}>
        <CircularProgress color="secondary" />
      </Backdrop>
    );
  }

  if (fetchBillingResultsFailed) return null;

  if (!billingResult) return null;

  return (
    <div className={styles.container}>
      <Overview billingResult={billingResult} />
      {filteredBillingParts.map((part) => (
        <BillingPart key={part.Code} part={part} />
      ))}
    </div>
  );
};

export default BillingResult;
